import { ButtonHTMLAttributes } from 'react';
import clsx from 'clsx';

import classes from './styles.module.scss';

const ButtonBase = (props: ButtonHTMLAttributes<HTMLButtonElement>) => {
    const { className, ...restProps } = props;

    return <button className={clsx(classes.root, className)} type="button" {...restProps} />;
};

export default ButtonBase;
